import styled from "styled-components";

export const ExternalLink = styled.a``;

ExternalLink.defaultProps = {
	target: "_blank",
	rel: "noopener noreferrer",
};
